function normalizeUuid(value) {
  const normalizedValue = `${value ?? ''}`.trim()
  if (!normalizedValue) return null

  const lowered = normalizedValue.toLowerCase()
  if (lowered === 'undefined' || lowered === 'null') return null
  return normalizedValue
}

function sanitizeUuids(values) {
  if (!Array.isArray(values)) return []
  return values.map(normalizeUuid).filter(Boolean)
}

export default {
  extractUuids: params => {
    const rawValues = Array.from(params.entries())
      .filter(keyValuePair => keyValuePair[0].startsWith('uuids['))
      .map(keyValuePair => keyValuePair[1])

    return sanitizeUuids(rawValues)
  },
  sanitizeUuid: normalizeUuid,
  sanitizeUuids
}
